export const withoutInitialSlashes = (str: string) => str.replace(/^\/*/, '');
